module.exports = __webpack_public_path__ + "static/bc-06-c6724941f2ece57cc5c4f1e3e074a823.jpg";